// this is in a separate module from low_bandwidth_metrics_observer.ts to work around
//     https://github.com/kulshekhar/ts-jest/issues/281
export var BandwidthLevel;
(function (BandwidthLevel) {
    BandwidthLevel["LOW"] = "Low";
    BandwidthLevel["NORMAL"] = "Normal";
    BandwidthLevel["NONE"] = "None";
})(BandwidthLevel || (BandwidthLevel = {}));
//# sourceMappingURL=bandwidth_level.js.map